module.exports = __webpack_public_path__ + "static/header-stories-4adeab47fc0c2c47c549b8bf4f71402b.jpg";